import PartnerProducts from "./PartnerProducts";

export default PartnerProducts;
